module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eric Marcus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" Eric Marcus is the author of several books and coauthor of "), _c('I', [_vm._v(" Breaking the Surface")]), _vm._v(", the number one "), _c('I', [_vm._v(" New York Times")]), _vm._v(" bestselling autobiography of Olympic diving champion Greg Louganis. ")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DU7SQj/tc-custom/9780061745287.jpg?1732137007740",
      "alt": "This image is the cover for the book Is It a Choice?"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Is It a Choice?\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The answers to all the questions you've ever had about sexual orientation but were afraid to ask. Eric Marcus provides insightful, no-nonsense answers to hundreds of the most commonly asked questions about same-sex orientation. Offering frank and accepting insight on everything you've always wanted-and needed-to know about same-gender relationships, coming out, family roles, politics, and much more, including:")]), _vm._v(" "), _c('p', [_vm._v("How do you know if you're gay or lesbian?")]), _c('p', [_vm._v("What should you do if your child is gay or lesbian?")]), _c('p', [_vm._v("Do gay parents raise gay children?")]), _c('p', [_vm._v("What does the Bible say about homosexuality?")]), _c('p', [_c('br')]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0